export default "__VITE_ASSET__D8VJYHc1__"